import { Controller } from "@hotwired/stimulus"

// Shows / hides price-band editors when pricing_model is "tiered"
// (or blank inherit + UsageUnit is already tiered → inherited readonly panel).
export default class extends Controller {
  static targets = ["select", "panel", "inheritedPanel", "editablePanel"]
  static values = { inheritedTiered: { type: Boolean, default: false } }
  static classes = ["hidden"]

  connect() {
    this.sync()
  }

  sync() {
    const selected = this.hasSelectTarget ? this.selectTarget.value : ""
    const inheritTiered = selected === "" && this.inheritedTieredValue
    const explicitTiered = selected === "tiered"

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle(this.hiddenClass, !(inheritTiered || explicitTiered))
    })

    this.inheritedPanelTargets.forEach((panel) => {
      panel.classList.toggle(this.hiddenClass, !inheritTiered)
    })

    this.editablePanelTargets.forEach((panel) => {
      panel.classList.toggle(this.hiddenClass, !explicitTiered)
    })
  }
}
